import { PaginationState, RowSelectionState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import {
  FindProductsProductStandardDto,
  ProductStandardsItemResponseDto,
} from "~/gen/api"
import { useProductsStandardsColumns } from "~/pages/Brand/Products/List/Components/ProductsTables/standards/standards-columns"

export type Props = {
  pagination: PaginationState
  rowSelection: RowSelectionState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
  pageCount: number
  standardHeaders: FindProductsProductStandardDto[]
  onStandardClick: (standard: FindProductsProductStandardDto) => void
  products: ProductStandardsItemResponseDto[]
}

export const useStandardsTable = ({
  pagination,
  rowSelection,
  setPagination,
  setRowSelection,
  pageCount,
  standardHeaders,
  onStandardClick,
  products,
}: Props) => {
  const columns = useProductsStandardsColumns(standardHeaders, onStandardClick)

  const table = useCustomReactTable({
    data: products,
    columns,
    initialColumnPinning: {
      left: ["name", "brandReference"],
    },
    state: {
      pagination,

      rowSelection,
    },
    pageCount,
    manualPagination: true,
    enableRowSelection: true,
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
  })

  return table
}
